import {FC, useState} from 'react';
import {Viewer} from '@bytemd/react';
import gfm from '@bytemd/plugin-gfm';

import 'bytemd/dist/index.min.css';
import highlight from '@bytemd/plugin-highlight';
import {Radio} from 'antd';

import config from './config';


const plugins = [
  gfm(), highlight(),
  // Add more plugins here
];

export const DevPlayGround: FC = () => {
  const value = `
  # Hello, *world*! 
  today is a good day. 
  
  Some Code Here:
  
  \`\`\`go
  package main
  import "fmt"
  
  func main() {
      fmt.Println("Hello")   
  }
  \`\`\`
  `;

  const [style, setStyle] = useState('a11ylight');

  const onChange = (e: any) => {
    console.log('radio checked', e.target.value);
    setStyle(e.target.value);
  };

  // const S = styleSwitch(style);
  const S : FC = (args)=>{
    return <>{args.children}</>;
  };
  return <>
    <Radio.Group onChange={onChange} value={style}>
      <Radio value={''}>A</Radio>
      <Radio value={'a11ydark'}>B</Radio>
      <Radio value={'a11ylight'}>C</Radio>
    </Radio.Group>

    <S><Viewer
      value={value}
      plugins={plugins}
    /></S>
    <p>{JSON.stringify(config)}</p>
  </>;
};

